export enum AddComponentType {
	CommonCode = 0,
	StockMaster = 1,
	DefaultLedger = 2,
	User = 3,
	CompanyMaster = 4,
	ManageTenants = 5,
}
